var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google_play",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217.615,
    height: 64.053,
    viewBox: "0 0 217.615 64.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4956",
    width: 217.615,
    height: 64.053,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10856",
    d: "M37,31.977v.47l6.637,6.639L43.787,39l7.863-4.468c2.246-1.276,2.246-3.364,0-4.64l-7.862-4.468-.151-.085Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.19,
    y1: 2.816,
    x2: -2.13,
    y2: 2.816,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gold"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#fdce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f9a700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#f68e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10857",
    d: "M16.971,52.24c.741.784,1.963.882,3.34.1L43.787,39,37,32.212Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.4,
    y1: 1.133,
    x2: -0.371,
    y2: 1.133,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de202d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b60054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10858",
    d: "M16.971,12.183,37,32.212l6.789-6.788L20.311,12.085a3.691,3.691,0,0,0-1.8-.54,2.059,2.059,0,0,0-1.539.638",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.405,
    y1: 1.755,
    x2: -0.375,
    y2: 1.755,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d8952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#2e8951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#559d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#6eaa46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77af45"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16643",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10852",
    d: "M209.426,63.246H8.19A7.382,7.382,0,0,1,.808,55.864V8.191A7.383,7.383,0,0,1,8.19.808H209.426a7.383,7.383,0,0,1,7.382,7.383V55.864a7.382,7.382,0,0,1-7.382,7.382",
    fill: "#050a0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10853",
    d: "M209.425,64.053H8.189A8.2,8.2,0,0,1,0,55.863V8.19A8.2,8.2,0,0,1,8.189,0H209.425a8.2,8.2,0,0,1,8.19,8.19V55.863a8.2,8.2,0,0,1-8.19,8.19M8.189,1.615A6.582,6.582,0,0,0,1.615,8.19V55.863a6.581,6.581,0,0,0,6.574,6.574H209.425A6.581,6.581,0,0,0,216,55.863V8.19a6.582,6.582,0,0,0-6.574-6.575Z",
    fill: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10854",
    d: "M109.776,35.03a6.841,6.841,0,1,0,6.867,6.84,6.743,6.743,0,0,0-6.867-6.84m0,10.986a4.157,4.157,0,1,1,3.861-4.146,3.957,3.957,0,0,1-3.861,4.146M94.8,35.03a6.841,6.841,0,1,0,6.866,6.84A6.742,6.742,0,0,0,94.8,35.03m0,10.986a4.157,4.157,0,1,1,3.86-4.146,3.957,3.957,0,0,1-3.86,4.146M76.978,37.128v2.9h6.944a6.049,6.049,0,0,1-1.581,3.654,7.106,7.106,0,0,1-5.363,2.125,7.723,7.723,0,0,1,0-15.444,7.4,7.4,0,0,1,5.234,2.073l2.047-2.047a10.124,10.124,0,0,0-7.281-2.928,10.625,10.625,0,1,0,0,21.248,9.712,9.712,0,0,0,7.41-2.98A9.588,9.588,0,0,0,86.9,38.942a9.441,9.441,0,0,0-.156-1.814Zm72.872,2.255a6.356,6.356,0,0,0-5.856-4.353,6.5,6.5,0,0,0-6.452,6.84,6.7,6.7,0,0,0,6.789,6.841,6.806,6.806,0,0,0,5.7-3.032L147.7,44.125a3.908,3.908,0,0,1-3.369,1.891,3.481,3.481,0,0,1-3.317-2.073l9.147-3.783Zm-9.328,2.28a3.752,3.752,0,0,1,3.576-3.99,2.646,2.646,0,0,1,2.539,1.451ZM133.085,48.3h3.006V28.189h-3.006Zm-4.923-11.738h-.1a4.743,4.743,0,0,0-3.6-1.528,6.847,6.847,0,0,0,0,13.681,4.666,4.666,0,0,0,3.6-1.555h.1v.985c0,2.617-1.4,4.016-3.653,4.016a3.783,3.783,0,0,1-3.446-2.436l-2.618,1.089a6.52,6.52,0,0,0,6.064,4.042c3.524,0,6.5-2.073,6.5-7.126V35.444h-2.851Zm-3.446,9.458a4.161,4.161,0,0,1,0-8.292c2.047,0,3.654,1.762,3.654,4.172a3.823,3.823,0,0,1-3.654,4.12M163.93,28.189h-7.191V48.3h3V40.678h4.191a6.254,6.254,0,1,0,0-12.489m.078,9.691h-4.269V30.988h4.269a3.447,3.447,0,1,1,0,6.892m18.547-2.888a5.636,5.636,0,0,0-5.355,3.079l2.665,1.112a2.843,2.843,0,0,1,2.741-1.474c1.553,0,3.131.931,3.156,2.586V40.5a6.642,6.642,0,0,0-3.13-.776c-2.871,0-5.794,1.578-5.794,4.527,0,2.69,2.354,4.424,4.992,4.424a4.235,4.235,0,0,0,3.829-1.966h.1v1.552h2.9V40.554c0-3.57-2.665-5.562-6.105-5.562m-.362,11.02c-.983,0-2.354-.491-2.354-1.707,0-1.552,1.707-2.147,3.181-2.147a5.342,5.342,0,0,1,2.742.672,3.637,3.637,0,0,1-3.569,3.182m17.021-10.58-3.441,8.718h-.1l-3.57-8.718h-3.233l5.354,12.184-3.052,6.777h3.13l8.252-18.961ZM172.182,48.3h3V28.189h-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10855",
    d: "M16.971,12.183a3.215,3.215,0,0,0-.744,2.258V49.982a3.213,3.213,0,0,0,.744,2.258l.119.117L37,32.447v-.47L17.09,12.067Z",
    fill: "#55bff1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16646",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16645",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4957",
    width: 16.897,
    height: 13.747,
    transform: "translate(36.999 25.339)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16648",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16647",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4958",
    width: 33.747,
    height: 33.747,
    transform: "translate(6.516 42.667) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16650",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16649",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4959",
    width: 33.576,
    height: 33.576,
    transform: "translate(6.637 21.878) rotate(-45)",
    fill: "url(#linear-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16652",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16651",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10859",
    d: "M73.925,13.32a3.436,3.436,0,0,0-2.279-.879,3.548,3.548,0,0,0-3.5,3.64,3.535,3.535,0,0,0,3.5,3.625,2.746,2.746,0,0,0,3.021-2.555H71.975V16.039h4.147c0,3.324-1.771,4.889-4.476,4.889a4.856,4.856,0,0,1,0-9.71,4.68,4.68,0,0,1,3.2,1.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10860",
    d: "M83.472,11.329v1.194H79.146v3.022h3.777V16.74H79.146V19.6h4.463v1.194h-5.74V11.329Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10861",
    d: "M91.754,11.329v1.208h-2.87v8.254H87.592V12.537h-2.87V11.329Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4960",
    width: 1.277,
    height: 9.462,
    transform: "translate(96.603 11.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10862",
    d: "M106.587,11.329v1.208h-2.87v8.254h-1.291V12.537h-2.87V11.329Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10863",
    d: "M115.6,11.218a4.856,4.856,0,1,1-4.779,4.863,4.8,4.8,0,0,1,4.779-4.863m0,8.474a3.527,3.527,0,0,0,3.516-3.611,3.511,3.511,0,1,0-7.018,0,3.523,3.523,0,0,0,3.5,3.611",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10864",
    d: "M127.96,20.791l-4.312-7.127v7.127H122.37V11.329h1.264L127.9,18.4V11.329h1.278v9.462Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.ff064f3e627e74a4390a96e7f4cd6576.svg";
export { ForwardRef as ReactComponent };